.DetailsAmountContainer
    height: 40px
    gap: 4px
    padding-left: 6px
    background: rgb($globalSettingsBackgroundSecondary)
    border: 0
    box-shadow: none
    overflow: visible
    .AmountInput, .AmountButton
        width: 27px
        height: 27px
        background: rgb($globalSettingsBackgroundSecondary)
        &:hover
            background: rgb($globalSettingsBackgroundTertiary)
    .CartButton
        background: rgb($globalSettingsBackgroundPrimary)
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
    .Disabled
        background: rgb($globalSettingsBackgroundSecondary)
        stroke: rgba($globalSettingsFontTertiary, 0.5)
        &:active
            background: rgb($globalSettingsBackgroundSecondary)
            stroke: rgba($globalSettingsFontTertiary, 0.5)
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
            stroke: rgba($globalSettingsFontTertiary, 0.5)
    .TextButtonContainer
        height: 100%
        display: flex
        flex-direction: row
        align-items: center
        justify-content: center
        gap: 5px
        padding: 0 10px
        font-size: 14px
        flex-grow: 1
        box-sizing: border-box
        border-radius: $globalButtonRounding
        border: 1px solid rgb($globalSettingsStrokeSecondary)
        background: rgb($globalSettingsBackgroundPrimary)
        stroke: rgb($globalSettingsFontSecondary)
        box-shadow: $globalButtonShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalButtonShadowSecondary rgba($globalSettingsBackgroundShadowColor,0.05)
    .TextButtonActive
        cursor: pointer
        &:hover
            background: rgb($globalSettingsBackgroundSecondary)
        &:active
            background: rgb($globalSettingsBackgroundPrimary)
            transition: background 0s
